import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { sendMessages } from "api/services/user-service";
import { useCallback } from "react";

export const useSendMessages = () => {
    const { callAPI, loading } = useWorkspaceApiCall(sendMessages, 'sendMessages.success', 'sendMessages.error');

    const sendEmails = useCallback(async (emails: string[], subject: string, message: string) => {
        return await callAPI({ emails, subject, message });
    }, [callAPI]);

    return { sendMessages: sendEmails, sendingMessages: loading };
}